import { IPageState, EPageKind } from '../types/page';

export const defaultState: IPageState = {
  kind: EPageKind.Default,
  section: 'index',
};
